import axios from 'axios';
import React, { useState, useEffect } from 'react';
import {connect} from 'react-redux';
import { Field, reduxForm, getFormValues, reset, SubmissionError } from 'redux-form';
import Select from 'react-select';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import { Button } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CircularProgress from '@material-ui/core/CircularProgress';
import NativeSelect from '@material-ui/core/NativeSelect';
import TextField from '@material-ui/core/TextField';
import css from '../Modals/./Modals.css';
import { customStylesSplit200, customStylesSplit450, customStylesSplit350 } from '../UI/select-styles';
import { write } from './qifHelper';
import { ROOT_URL } from "../../Actions/types";

let CSV = (props) => {
    const { selectOptions, processTXT, processCSV, confirmType, file, error, pristine } = props;
    const [checked, setChecked] = React.useState(true);
    const [selectVal, setSelectVal] = React.useState(',');
    const [textQualifier, setTextQualifier] = React.useState('"');
    const [character, setCharacter] = React.useState('');
    const isSubmittingOrSucceeded = props.submitting || props.submitSucceeded;
    
    const handleChange = (event) => {
        setChecked(event.target.checked);
    };

    const handleSelectChange = (event) => {
        resetCSVForm();
        const newSelectVal = event.target.value;
        setSelectVal(newSelectVal);
        setCharacter('');
        if (newSelectVal === 'others') {
            setCharacter('');
            processTXT(file, ',', textQualifier);
        } else {
            processTXT(file, newSelectVal, textQualifier);
        }
    }

    const handleTextQualifierSelectChange = (event) => {
        resetCSVForm();
        const newTextQualifier = event.target.value;
        const newSelectVal = character || (selectVal === 'others' ? ',' : selectVal);
        setTextQualifier(newTextQualifier);
        confirmType === 'txt' ? processTXT(file, newSelectVal, newTextQualifier) : processCSV(file, newTextQualifier);
    }

    const resetCSVForm = () => {
        props.reset('csvForm');
    }

    const useStyles = makeStyles({
        container: {
            minHeight: 300,
            maxHeight: 325,
            minWidth: 650,
        },
        tableCell: {
            padding: 5,
            minWidth: 125
        },
        disabledCell: {
            cursor: 'default',
            backgroundColor: '#f5f5f5',
            color: '#aaa',
            textShadow: '1px 1px 0 #fff',
        },
        button: {
            width: 164
        },
        select: {
            marginLeft: 12,
            fontSize: 14
        },
        textQualifier: {
            paddingLeft: 10,
            width: 34
        }
      });
    const classes = useStyles();
    const optionStyle = {
        option: (provided, state) => ({
            ...provided,
            height: 30,
            padding: 2,
            paddingLeft: 10
          }),
    }

    const rows = props.columns.length > 5 ? props.columns.slice(0, 5) : props.columns;

    useEffect(() => {
        const hasHeader = props.columns[0] && props.columns[0].every(column => isNaN(column));
        setChecked(!!hasHeader)
    }, [props.columns])

    const handleSubmit = (values) => {
        let isDateColumn = false;
        let isAmountColumn = false;
        let isRevAmountColumn = false;
        let isMoneyIn = false;
        let isMoneyOut = false;
        Object.values(values).forEach(e => {
            if (e.value === 'date') isDateColumn = true;
            else if (e.value === 'amount') isAmountColumn = true;
            else if (e.value === 'revAmount') isRevAmountColumn = true;
            else if (e.value === 'moneyIn') isMoneyIn = true;
            else if (e.value === 'moneyOut') isMoneyOut = true;
        })
        if (!(isDateColumn && (isAmountColumn || isRevAmountColumn|| (isMoneyIn && isMoneyOut)))) {
            throw new SubmissionError({ _error: 'Please specify date, and use either (reversed) amount, or (money in/out) columns' })
        }

        let isInvalidAmount = false;
        const columns = checked ? props.columns.slice(1) : props.columns;
        const columnsNew = columns.map(column => {
            const obj = {}
            column.map((cell, cellIndex) => {
                const dataType = values[cellIndex] ? values[cellIndex].value : '';
                obj[dataType] = cell;
                if (!isInvalidAmount && (dataType === 'amount' || dataType === 'revAmount' || dataType === 'moneyIn' || dataType === 'moneyOut') && isNaN(obj[dataType])) {
                    isInvalidAmount = true;
                }
            })
            return obj;
        })

        if (isInvalidAmount) {
            throw new SubmissionError({ _error: 'Please use Amount/Reversed Amount/Money In/Money Out for numeric values only' })
        }

        let qifData = write(columnsNew);
        let myblob = new Blob([qifData], { type: 'text/plain' });
        let newFile = new File([myblob], `${file.name}.qif`);

        const data = new FormData();
        data.append('file', newFile);
        return props.importCSV(data);
    }

    const renderDropdown = ({ input, defaultVal,  ...rest }) => {
        return (
          <div>
              <Select {...input} {...rest}
                isDisabled={isSubmittingOrSucceeded}
                onBlur={() => input.change}
                isOptionDisabled={option => (option.isAssignedTo !== input.name) && option.isAssignedTo !== null && option !== selectOptions[0]}
                value={input.value || selectOptions[0]}
                onChange={(value) => {
                    selectOptions.forEach((o, i, a) => {
                        const option = a[i];
                        if (o.isAssignedTo === input.name) a[i].isAssignedTo = null;
                        if (o.value === value.value) a[i].isAssignedTo = input.name;
                    })
                    input.onChange(value)
                }}
                styles={optionStyle} 
                options={selectOptions} />
          </div>
        )
    };

    const renderSelect = () => {
        return (
            <NativeSelect
            onChange={handleSelectChange}
            name="select"
            className={classes.select}
            inputProps={{ 'aria-label': 'character' }} >
                <option value=",">Comma</option>
                <option value={"\t"}>Tab</option>
                <option value={"others"}>Other Char</option>
            </NativeSelect>
        )
    }

    const renderTextQualifierSelect = () => {
        return (
            <NativeSelect
            onChange={handleTextQualifierSelectChange}
            name="text-qualifier-select"
            classes={{select: classes.textQualifier}}
            className={classes.select}
            inputProps={{ 'aria-label': 'qualifier' }} >
                <option value='"'>"</option>
                <option value="'">'</option>
                <option value={""}>None</option>
            </NativeSelect>
        )
    }

    let buttonText = 'Confirm Import';
    if (props.submitting) buttonText = <CircularProgress size={24} />;
    if (props.submitSucceeded) buttonText = <CheckIcon size={24} />;

    const onCharacterChange = e => {
        const newValue = e.target.value;
        const isSpecialCharater = /^[/?><`~!@#\$%\^\&*\)\(+=,._-]?$/.test(newValue);
        if (isSpecialCharater) setCharacter(newValue);
        else setCharacter('');
    }

    const onCharacterBlur = e => {
        const newValue = e.target.value
        if (newValue) processTXT(file, newValue, textQualifier);
    }

    return (
        <div className={css.container}>
            <form onSubmit={props.handleSubmit(handleSubmit)}>
                <h3>Import Transactions</h3>
                <div className={css.infoBox}>
                    <p className={css.ml10}><strong>{props.columns.length - (checked ? 1 : 0)}</strong> Transactions will be imported (File: <strong>{file.name}</strong>)</p>
                    <div className={[css.flexEnd, css.mb11].join(' ')}>
                        <div className={[css.ml10, css.mb10, css.grey, css.font15].join(' ')}>Data preview (first 5 rows)</div>
                        <div className={[css.font14, css.pr8, css.endText].join(' ')}>
                            <div>
                                <Checkbox
                                disabled={isSubmittingOrSucceeded}
                                checked={checked}
                                onChange={handleChange}
                                size="small"
                                inputProps={{ 'aria-label': 'primary checkbox' }}/> 
                                Includes header record
                            </div>
                            {<div className={[css.ml10, css.mb3].join(' ')}>
                                Text qualifier: 
                                {renderTextQualifierSelect()}
                            </div>}
                            {confirmType === 'txt' && <div className={[css.ml10, css.mb3].join(' ')}>
                                Separated by: 
                                    {renderSelect()}
                                    {selectVal === "others" && 
                                    <TextField 
                                    onChange={onCharacterChange}
                                    onBlur={onCharacterBlur}
                                    value={character}
                                    InputProps={{
                                        style: {
                                            marginLeft: 12,
                                            fontSize: 16,
                                            width: 45,
                                            height: 32,
                                        }
                                    }}
                                    variant="outlined" 
                                    size="small" />}
                            </div>}
                        </div>   
                    </div>
                    <p>
                        <TableContainer className={[classes.container, css.table].join(' ')} component={Paper}>
                            <Table stickyHeader aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        {props.columns[0] && props.columns[0].map((cell, i) => {
                                            return (<TableCell className={classes.tableCell} padding="checkbox" align="left">
                                                        <Field name={i} component={renderDropdown} />
                                                    </TableCell>)
                                        })}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row, i) => {
                                        let cellStyle = (i === 0 && checked) ? classes.disabledCell : '';
                                        return (
                                            <TableRow hover key={i}>
                                                {row.map((cell)=> <TableCell className={cellStyle} align="center">{cell}</TableCell>)}
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </p>
                </div>
                <label style={{ marginLeft: 10 }}>
                    <Button variant="contained" color="primary" className={classes.button} type="submit" disabled={pristine || isSubmittingOrSucceeded}>{buttonText}</Button>&nbsp;&nbsp;&nbsp;
                    <Button variant="contained" onClick={props.onClose}>Cancel</Button>
                </label>
                {(props.submitting) && <div className={css.message}>Importing transactions please wait...</div>}
                {error && !isSubmittingOrSucceeded && <div className={css.formErrorMessage}>{error}</div>}
            </form>
        </div>
    )
}

CSV = reduxForm({
    form: 'csvForm' 
})(CSV)
  
CSV = connect(state => {
    return { formValues: getFormValues('csvForm')(state) }
}, { reset })(CSV)

export default CSV;
  




// WEBPACK FOOTER //
// ./src/components/UploadTransactions/CSV.js